// =============================================
//  SAMPLE DATA (COST VALUES, NOT PERCENTAGES)
// =============================================
const itDepartmentData = [
  { label: 'Jan', engineering: 4000, qa: 3000, devops: 4500, product: 3500, design: 2500, support: 5000, security: 3000, infra: 4000, data: 2800 },
  { label: 'Feb', engineering: 6000, qa: 3500, devops: 5500, product: 4000, design: 3000, support: 5500, security: 4000, infra: 4800, data: 3500 },
  { label: 'Mar', engineering: 6000, qa: 3200, devops: 5000, product: 4200, design: 2800, support: 5200, security: 3800, infra: 4500, data: 3000 },
  { label: 'Apr', engineering: 4000, qa: 2800, devops: 4800, product: 3600, design: 2200, support: 4700, security: 3300, infra: 4000, data: 2600 },
  { label: 'May', engineering: 7000, qa: 4000, devops: 6500, product: 5000, design: 3500, support: 6000, security: 4500, infra: 5500, data: 3800 },
  { label: 'Jun', engineering: 5000, qa: 3200, devops: 5800, product: 4500, design: 3000, support: 5500, security: 4000, infra: 5000, data: 3300 },
  { label: 'Jul', engineering: 5000, qa: 3300, devops: 6000, product: 4800, design: 3200, support: 5300, security: 4200, infra: 5200, data: 3400 },
  { label: 'Aug', engineering: 4000, qa: 3000, devops: 4800, product: 3900, design: 2500, support: 4800, security: 3500, infra: 4500, data: 2900 },
  { label: 'Sep', engineering: 4500, qa: 3300, devops: 5200, product: 4200, design: 2700, support: 5000, security: 3800, infra: 4800, data: 3100 },
  { label: 'Oct', engineering: 4500, qa: 2800, devops: 5000, product: 4000, design: 2500, support: 4900, security: 3500, infra: 4600, data: 3000 },
  { label: 'Nov', engineering: 6500, qa: 3700, devops: 6000, product: 4800, design: 3400, support: 5800, security: 4300, infra: 5600, data: 3800 },
  { label: 'Dec', engineering: 6500, qa: 3800, devops: 6200, product: 5000, design: 3500, support: 6000, security: 4500, infra: 5800, data: 3900 }
];


// =======================================================
//        FINAL CONFIG – DUAL AXIS + DYNAMIC LINES
// =======================================================
const PayrollDeptCostChartConfig = (
  datas = itDepartmentData,
  xKey = 'label'
) => {

  if (!datas.length) return {};

  // Get department keys (everything except label)
  const departmentKeys = Object.keys(datas[0]).filter(
    key => key !== xKey
  );

  // Colors for lines
  const colors = [
    '#4C8DFF', '#45B6A8', '#F39C12', '#A66CFF', '#22A699',
    '#E74C3C', '#9B59B6', '#1ABC9C', '#28C76F', '#FF7F50'
  ];

  // Compute Total Cost per month
  const totalCostData = datas.map(row =>
    departmentKeys.reduce((sum, dept) => sum + row[dept], 0)
  );

  // Compute department percent contribution for line chart
  const percentSeries = (dept, row) => {
    const deptCost = row[dept];
    const total = departmentKeys.reduce((s, d) => s + row[d], 0);
    return Number(((deptCost / total) * 100).toFixed(1));
  };

  return {
    color: ['#7A6FF0', ...colors],

    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const month = params[0].name;

        const totalCost = params.find(p => p.seriesName === 'Total Cost')?.value;

        let str = `<b>${month}</b><br/>`;

        params.forEach((p) => {
          if (p.seriesName !== 'Total Cost') {
            const percent = p.value + '%';
            const dept = p.seriesName;
            const dollar = datas.find(r => r.label === month)[
              dept.toLowerCase()
            ];

            str += `${p.marker} ${dept}: $${dollar} (${percent})<br/>`;
          }
        });

        str += `<br/><b>Total Cost: $${totalCost}</b>`;
        return str;
      }
    },

    legend: {
      show: false,
      bottom: 0,
      data: ['Total Cost', ...departmentKeys.map(
        d => d.charAt(0).toUpperCase() + d.slice(1)
      )]
    },

    grid: {
      left: 0,
      right: 0,
      bottom: 50,
      top: 20,
      containLabel: true
    },

    xAxis: {
      type: 'category',
      data: datas.map(d => d[xKey]),
      axisLabel: { interval: 0 }
    },

    yAxis: [
      {
        type: 'value',
        name: 'Total Cost ($)',
        axisLabel: { formatter: (value) => `$${value}` }
      },
      {
        type: 'value',
        name: 'Department %',
        min: 0,
        max: 30,
        axisLabel: { formatter: '{value}%' }
      }
    ],

    series: [
      // BAR series (Total Cost)
      {
        name: 'Total Cost',
        type: 'bar',
        barWidth: 35,
        yAxisIndex: 0,
        data: totalCostData,
        itemStyle: {
          color: '#7A6FF0',
          borderRadius: [6, 6, 0, 0]
        },
        z: 2
      },

      // DYNAMIC LINES (Percent contribution)
      ...departmentKeys.map((dept, index) => ({
        name: dept.charAt(0).toUpperCase() + dept.slice(1),
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        symbol: 'circle',
        symbolSize: 8,
        lineStyle: { width: 3, color: colors[index % colors.length] },
        itemStyle: { color: colors[index % colors.length] },
        data: datas.map(row => percentSeries(dept, row))
      }))
    ]
  };
};

export default PayrollDeptCostChartConfig;
